<template>
  <div class="todoapp">
    <div class=" todo-header d-flex">
      <img width="50" height="50" alt="Vue logo" src="../src/assets/logo.png">
      <h1>todos</h1>
      <img width="50" height="50" alt="Vue logo" src="../src/assets/logo.png">
    </div>
    <br>
    <Todos />
  </div>
</template>

<script>
import Todos from '@/components/todos.vue'
export default {
  name: 'App',
  components: {
    Todos
  }
}
</script>

<style >
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
.todo-header{
  text-align: center;
  align-content: center;
  justify-content: center;
}
.todoapp h1 {

	top: 1px;
  margin-bottom: 20px;
  text-align: center;
	font-size: 100px;
	font-weight: 100;
	color: rgba(175, 47, 47, 0.15);
	-webkit-text-rendering: optimizeLegibility;
	-moz-text-rendering: optimizeLegibility;
	text-rendering: optimizeLegibility;
}
</style>
